/**
 * Client-side feature flags. Keep these in sync with the backend flags — hiding the UI here only
 * complements the hard server gate, it does not replace it.
 */

/**
 * Reading any spreadsheet into purchase requests, with a model proposing the column mapping.
 *
 * Gated by `feature.purchase-request-import.enabled` on the backend as well. Enable the UI with
 * REACT_APP_PR_IMPORT_ENABLED=true.
 */
export const isPurchaseRequestImportEnabled = (): boolean =>
  process.env.REACT_APP_PR_IMPORT_ENABLED === "true";

/**
 * The assistant that floats over every signed-in screen and knows which record is on it.
 *
 * The backend endpoints check access on every read, whatever this says. Enable the button with
 * REACT_APP_SCREEN_ASSISTANT_ENABLED=true.
 */
export const isScreenAssistantEnabled = (): boolean =>
  process.env.REACT_APP_SCREEN_ASSISTANT_ENABLED === "true";
